import { render } from "./UserDropdownItem.vue?vue&type=template&id=47dbad96"
import script from "./UserDropdownItem.vue?vue&type=script&lang=js"
export * from "./UserDropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__